module.exports = __webpack_public_path__ + "static/media/Vue.9a45fc76.svg";